import React from 'react';

import cn from 'classnames';

// import { SymbolState } from '@type/market';
import { KLineWeb } from '../KLineWeb';

import styles from './index.module.css';

export const TradeWebTop = (props) => {
  // const { isNewUser } = props
  // const [baseCurrency, quoteCurrency] = props?.coinArr || [];
  // const { riseFallIcon } = useHeader();
  // const asks = useMemo(() => {
  //   return props.asks.reverse()
  // }, [props.asks])

  // const allowTrade = useMemo(() => {
  //   return props?.tradeCoinDetail?.allowTrade && props?.tradeCoinDetail?.state !== SymbolState.EXPLORE
  // }, [props?.tradeCoinDetail]);

  return (
    <div className={cn(styles.wrapper)}>
      <KLineWeb {...props} kLineHeaderProps={props.kLineHeaderProps} />
      {/* {
        !isNewUser && allowTrade &&
        <div className={cn(styles.orderBook)}>
          <BaseOrderBook
            {...{
              bids: props.bids,
              asks,
              coinDetail: props.tradeCoinDetail
            }}
            riseFallIcon={riseFallIcon}
            header={<Header updateRiseFallIcon={updateRiseFallIcon} riseFallIcon={riseFallIcon} />}
            askHeader={<AskHeader quoteCurrency={quoteCurrency} />}
            bidHeader={<BidHeader price={props.kLineHeaderProps.price} value={props.kLineHeaderProps.value} priceClass={props.kLineHeaderProps.priceClass} />}
          />
        </div>} */}
      {/* {!isNewUser && allowTrade && <div className={cn(styles.buyAndSell)}>
        <BuyAndSellTabs
          baseCurrency={baseCurrency}
          coinDetail={props.tradeCoinDetail}
          assetCoinDetail={props.coinDetail}
          quoteCurrency={quoteCurrency}
        />
      </div>} */}
    </div>
  )
}
